import Grid from "@mui/material/Grid";
import classNames from "classnames";
import omit from "lodash/omit";
import { makeStyles } from "@mui/styles";
import { forwardRef } from "react";

const styles = {
    root: {},
    cardPadding0: {
        padding: 0
    },
    cardPadding1: {
        padding: 8
    },
    cardPadding2: {
        padding: 16
    },
    cardPadding3: {
        padding: 24
    },
    cardPadding4: {
        padding: 32
    },
    card: {
        background: "white",
        borderRadius: 8,
        boxShadow: "rgb(0 0 0 / 20%) 0px 1px 2px 0px"
    },
    elevation0: {
        // border: '1px solid rgb(209, 213, 221)',
        // borderRadius: 4,
    },
    elevation1: {
        boxShadow: "unset",
        backgroundColor: "#fafbfc"
    },
    elevation2: {
        boxShadow: "0 1px 3px 0 rgba(37,32,31,.3)"
        // backgroundColor: '',
    },
    offset: {
        margin: "0 -16px",
        width: "calc(100% + 32px)"
    },
    highlight: {
        boxShadow: "0px 1px 3px 0px rgb(154, 171, 179)"
    },
    borderHighlight: {
        borderColor: "#98b9ff"
    },
    halfPadding: {
        padding: 8
    },
    padding: {
        padding: 16
    },
    dense: {
        padding: 0
    },
    dashed: {
        borderStyle: "1px dashed rgb(209, 213, 221)"
    },
    paddingBottom0: {
        paddingBottom: 0
    },
    noWrap: {
        flexWrap: "nowrap"
    },
    clickable: {
        cursor: "pointer"
    },
    elevation3: {
        boxShadow: "0 5px 30px rgb(0 0 0 / 20%)"
        // backgroundColor: '',
    },
    greyed: {
        background: "rgba(208, 215, 222, 0.24)", // '#f0f0f0',
        borderRadius: "unset"
    }
};

const useStyles = makeStyles(styles);

const GridContainer = forwardRef(function GridContainer(props, ref) {
    const {
        children = null,
        className,
        spacing = 1,
        card,
        halfPadding,
        noWrap,
        onClick,
        padding,
        justify,
        justifyContent,
        alignItems,
        direction,
        dense,
        elevation = 0,
        shadow = false,
        highlight,
        borderHighlight,
        cardClassName,
        dashed,
        paddingBottom0,
        cardPadding = 2,
        padding3,
        greyed,
        sx = {}
    } = props;

    const classes = useStyles();

    const renderGrid = () => {
        if (!children) return null;

        return (
            <Grid
                ref={ref}
                container
                sx={{
                    width: "100%",
                    justifyContent: justify || justifyContent || undefined,
                    flexWrap: noWrap ? "nowrap" : "wrap",
                    alignItems: alignItems || undefined,
                    ...sx
                }}
                className={classNames(
                    classes.root,
                    className,
                    noWrap && classes.noWrap,
                    onClick && classes.clickable,
                    !card && halfPadding && classes.halfPadding,
                    padding && classes.padding,
                    className
                )}
                spacing={spacing}
                onClick={onClick}
                alignItems={alignItems || undefined}
                direction={direction || undefined}
                {...omit(props, [
                    "classes",
                    "children",
                    "className",
                    "spacing",
                    "card",
                    "dense",
                    "elevation",
                    "cardClassName",
                    "borderHighlight",
                    "shadow",
                    "dashed",
                    "halfPadding",
                    "noWrap",
                    "onClick",
                    "cardPadding",
                    "padding",
                    "justify",
                    "justifyContent",
                    "alignItems",
                    "direction",
                    "highlight",
                    "paddingBottom0",
                    "padding3",
                    "greyed"
                ])}
            >
                {children}
            </Grid>
        );
    };

    const renderCard = () => (
        <div
            className={classNames(
                classes.card,
                [shadow, elevation === 0] ? classes.shadow : null,
                highlight && classes.highlight,
                borderHighlight && classes.borderHighlight,
                classes[`elevation${elevation}`],
                classes[`cardPadding${cardPadding}`],
                dense && classes.dense,
                halfPadding && classes.halfPadding,
                paddingBottom0 && classes.paddingBottom0,
                dashed && classes.dashed,
                padding3 && classes.padding3,
                greyed && classes.greyed,
                cardClassName
            )}
        >
            {renderGrid()}
        </div>
    );

    return card ? renderCard() : renderGrid();
});

export default GridContainer;
